import { useMemo } from 'react';

import { useMerchant } from '@contexts/operator/MerchantContext';

import operatorApiFetch from '@services/operator/apiService';

/**
 * Operator Consumable Service Hook
 *
 * 提供 Operator 角色的 Consumable 服務方法
 * 自動注入當前 merchantId 到 create 請求
 */
export default function useOperatorConsumableService() {
  const { merchantId } = useMerchant();

  return useMemo(() => ({
    get: async (id) => {
      const res = await operatorApiFetch(`consumables/${id}`);
      return res.json();
    },

    create: async (data) => {
      const res = await operatorApiFetch('consumables', {
        method: 'POST',
        body: { merchant_id: merchantId, consumable: data }
      });
      return res.json();
    },

    update: async (id, data) => {
      const res = await operatorApiFetch(`consumables/${id}`, {
        method: 'PUT',
        body: { consumable: data }
      });
      return res.json();
    },

    checkBarcode: async (barcode) => {
      const res = await operatorApiFetch(`consumables/check_barcode?barcode=${encodeURIComponent(barcode)}`);
      return res.json();
    },
  }), [merchantId]);
}
